import { validateInboxSearch } from '@inbox/features/inbox-filters';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute, redirect } from './_root';

// Inbox is TEMPORARILY DISABLED while its functionality is incomplete: every
// /inbox* route redirects to the itineraries list via `beforeLoad`. The real
// page components + search wiring below are intentionally kept intact — to
// re-enable the feature, delete the `beforeLoad: redirectToItineraries` line
// from each route (and unhide the sidebar item in `widgets/app-layout`).
const redirectToItineraries = () => {
  throw redirect({ to: '/itineraries' });
};

export const inboxRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'inbox',
  beforeLoad: redirectToItineraries,
  component: lazyRouteComponent(() =>
    import('@inbox/pages/inbox').then((m) => ({
      default: m.InboxPage,
    }))
  ),
  validateSearch: (input: Record<string, unknown>) =>
    validateInboxSearch(input),
});

export const inboxNewRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'inbox/new',
  beforeLoad: redirectToItineraries,
  component: lazyRouteComponent(() =>
    import('@inbox/pages/inbox-compose').then((m) => ({
      default: m.InboxComposePage,
    }))
  ),
});

export const inboxThreadRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'inbox/$threadId',
  beforeLoad: redirectToItineraries,
  component: lazyRouteComponent(() =>
    import('@inbox/pages/conversation').then((m) => ({
      default: m.ConversationPage,
    }))
  ),
});
